import React from 'react';
import classes from './Dice.css';

const dice = (props) => {
    let diceClass = [classes.Dice];
    if(props.roll){
        diceClass.push(classes.Active);
    }
    return (
        <div className={classes.DiceHolder}>
            <div className={diceClass.join(" ")}>
                <div className={classes.Front}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className={classes.Back}>
                    <span></span>
                </div>
                <div className={classes.Right}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className={classes.Left}>
                    <span></span>
                    <span></span>
                </div>
                <div className={classes.Top}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className={classes.Bottom}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    )
}

export default dice;


// WEBPACK FOOTER //
// ./src/components/Dice/Dice.js